/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  RsiRequestLog,
  RsiRequestLogs,
  RsiRequestLogsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary RSI Request Logs list
 */
export const rsiRequestLogs = (
    params?: MaybeRefOrGetter<RsiRequestLogsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<RsiRequestLogs>(
      {url: `/rsi-request-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getRsiRequestLogsQueryKey = (params?: MaybeRefOrGetter<RsiRequestLogsParams>,) => {
    return [
    'rsi-request-logs', ...(params ? [params] : [])
    ] as const;
    }


export const getRsiRequestLogsQueryOptions = <TData = Awaited<ReturnType<typeof rsiRequestLogs>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<RsiRequestLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rsiRequestLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRsiRequestLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rsiRequestLogs>>> = ({ signal }) => rsiRequestLogs(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rsiRequestLogs>>, TError, TData>
}

export type RsiRequestLogsQueryResult = NonNullable<Awaited<ReturnType<typeof rsiRequestLogs>>>
export type RsiRequestLogsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary RSI Request Logs list
 */

export function useRsiRequestLogs<TData = Awaited<ReturnType<typeof rsiRequestLogs>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<RsiRequestLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rsiRequestLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRsiRequestLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Resolve RSI Request Log
 */
export const resolveRsiRequestLog = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<RsiRequestLog>(
      {url: `/rsi-request-logs/${id}/resolve`, method: 'PUT', signal
    },
      );
    }




export const getResolveRsiRequestLogMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveRsiRequestLog>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resolveRsiRequestLog>>, TError,{id: string}, TContext> => {

const mutationKey = ['resolveRsiRequestLog'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveRsiRequestLog>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  resolveRsiRequestLog(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveRsiRequestLogMutationResult = NonNullable<Awaited<ReturnType<typeof resolveRsiRequestLog>>>

    export type ResolveRsiRequestLogMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Resolve RSI Request Log
 */
export const useResolveRsiRequestLog = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveRsiRequestLog>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resolveRsiRequestLog>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getResolveRsiRequestLogMutationOptions(options), queryClient);
    }
